import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import {
  ApplicationModule,
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
// import { ProgressModule } from "../views/progress/progress.module";
import { DndDirective } from '../directives/dnd.directive';
import { SnackBarService } from '../services/snackBar/snack-bar-service.service';
import { MaterialAngularModule } from './materialAngular.module';
import { NgxEditorModule } from 'ngx-editor';
import { LoadingBtnDirective } from '../directives/loading-btn/loading-btn.directive';
import { AppRoleDirective } from '../directives/appRoles/app-role.directive';
import { NavPanelPersonaComponent } from '@views/personas/nav-panel-persona/nav-panel-persona.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { SinDatosParaMostrarComponent } from 'src/app/component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { DynamicPipe } from '@pipes/dynamicPipe.pipe';

@NgModule({
  imports: [
    CommonModule,
    ApplicationModule,
    MaterialAngularModule,
    FormsModule,
    RouterModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxEditorModule,
    NgxMaskDirective,
    NgxMaskPipe,
  ],
  declarations: [
  ],
  providers: [
    SnackBarService,
    HttpClient],
  exports: [
    CommonModule,
    ApplicationModule,
    MaterialAngularModule,
    FormsModule,
    RouterModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxEditorModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
